import { CommonHeader, PlaceInfo } from '~/components';
import styles from './Place.module.scss';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useStore } from '~/store';

function Place() {
    const [state] = useStore();
    const { places } = state;

    return (
        <div className={styles.wrapper}>
            <CommonHeader title={'ĐỊA ĐIỂM (TỈNH/TP/...)'} />
            <TransitionGroup className={styles.list}>
                {places.map((place) => (
                    <CSSTransition
                        key={place.id}
                        timeout={1000}
                        classNames="item"
                    >
                        <PlaceInfo key={place.id} {...place} />
                    </CSSTransition>
                ))}
            </TransitionGroup>
        </div>
    );
}

export default Place;
